import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Imagine() {
  return <section className="py-14 bg-olive-50 border-y border-olive-100" data-id="element-189">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-191">
          <StarIcon className="h-8 w-8 text-terracotta-400 mx-auto mb-8" strokeWidth={1.5} data-id="element-192" />

          <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-12" data-id="element-193">
            Imagina esto
          </h2>

          <div className="space-y-8 text-xl text-charcoal/80 font-light italic mb-16" data-id="element-194">
            <p data-id="element-195">
              "Imagina levantarte mañana, abrir tu closet y saber exactamente
              qué ponerte. Sin dudas. Sin el ritual de los 7 outfits fallidos.
              Sin llegar al trabajo sintiéndote 'meh'."
            </p>
            <p data-id="element-196">
              "Imagina entrar a tu próxima reunión importante con esa sensación
              de que te ves exactamente como la persona que eres."
            </p>
            <p data-id="element-197">
              "Imagina que la primera impresión que das — antes de hablar, antes
              de presentarte — ya está trabajando a tu favor."
            </p>
          </div>

          <div className="p-8 bg-white border border-olive-100 shadow-sm" data-id="element-198">
            <p className="text-lg text-charcoal/60 uppercase tracking-widest text-sm mb-2" data-id="element-199">
              Eso no es un sueño de moda.
            </p>
            <p className="text-2xl font-display text-olive-600" data-id="element-200">
              Eso es lo que pasa cuando tienes las prendas correctas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}